// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1umrL","actionsCol":"EnrolledClinics_actionsCol__3C8kM"};